<template>
  <div class="step-area">
    <div class="step-area__wrap">
      <div
        class="step-area__item"
        :class="{ current: index === 1}">
        <div class="step-area__circle"></div>
        <div class="step-area__num">
          <span>STEP1</span><br>
          {{ isRevenuePage ? 'リリース選択' : 'アーティスト' }}<br class="sp" />{{ isRevenuePage ? '' : '選択' }}
        </div>
      </div>
      <div
        class="step-area__item"
        :class="{ current: index === 2}">
        <div class="step-area__circle"></div>
        <div class="step-area__num">
          <span>STEP2</span><br>
          {{ isRevenuePage ? 'スプリット設定' : 'リリース情報' }}
          <br class="sp" />{{ isRevenuePage ? '' : '登録' }}
        </div>
      </div>
      <div
        class="step-area__item"
        :class="{ current: index === 3}">
        <div class="step-area__circle"></div>
        <div class="step-area__num">
          <span>STEP3</span><br>
          {{ isRevenuePage ? '内容確認' : '配信ストア' }}
          <br class="sp" />{{ isRevenuePage ? '' : '選択' }}
        </div>
      </div>
      <div
        v-if="isBtoC && !isRevenuePage"
        class="step-area__item"
        :class="{ current: index === 4 }">
        <div class="step-area__circle"></div>
        <div class="step-area__num"><span>STEP4</span><br>アカウント<br class="sp" />情報</div>
      </div>
      <div
        v-if="isBtoC && !isRevenuePage"
        class="step-area__item"
        :class="{ current: index === 5, disabled: isSubscriber}">
        <div class="step-area__circle"></div>
        <div class="step-area__num">
          <span>STEP5</span><br>
          <template v-if="isMate">
            登録完了
          </template>
          <template v-else>
            決済情報<br class="sp" />登録
          </template>
        </div>
      </div>
      <div class="step-area-bar"></div>
    </div>
    <div class="step-area__text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReleaseStepArea',
  props: {
    index: {
      type: Number,
      default: 1,
    },
    isRevenuePage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('auth', ['isSubscriber', 'isMate']),
  },
}
</script>
